import { styled } from '@mui/material/styles'
import Box, { BoxProps } from '@mui/material/Box'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import Button, { ButtonProps } from '@mui/material/Button'
import Avatar, { AvatarProps } from '@mui/material/Avatar'

export const Container = styled(Box)<BoxProps>({
  flexGrow: 1
})

export const HeaderBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: '0 16px',
  backgroundColor: theme.palette.background.primary,
  [theme.breakpoints.down('tablet')]: {
    padding: '0 8px'
  }
}))

export const HeaderIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.button?.hover
    }
  })
)

export const MobileLogo = styled(Button)<ButtonProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginLeft: 8,
  outline: 'none',
  color: theme.palette.background.primary,
  minWidth: '0px !important',
  paddingLeft: 10,
  paddingRight: 10,
  '&:hover': {
    backgroundColor: theme.palette.background.primary
  }
}))

export const TituloBox = styled(Box)<BoxProps>({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginLeft: 32
})

export const ButtonBox = styled(Button)<ButtonProps>(({ theme }) => ({
  display: 'flex',
  border: 'none',
  color: theme.palette.background.primary,
  minWidth: '0px !important',
  paddingLeft: 10,
  paddingRight: 10,
  '&:hover': {
    backgroundColor: theme.palette.background.primary
  },
  '&:active': {
    backgroundColor: theme.palette.background.primary
  }
}))

export const UnidadeOrganizacionalBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,

  hr: {
    borderWidth: 1,
    height: 20,
    borderColor: theme.palette.border?.terciary,
    borderRadius: 1
  },

  h1: {
    fontSize: 14,
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: theme.palette.text.primary
  }
}))

export const MenuAvatar = styled(Avatar)<AvatarProps>(({ theme }) => ({
  width: 32,
  height: 32,
  fontSize: 14,
  backgroundColor: theme.palette.border?.secondary,
  color: theme.palette.text.primary
}))

export const MenuContaButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  marginLeft: 'auto',

  '&:hover': {
    backgroundColor: theme.palette.button?.hover
  }
}))
